module.exports = __webpack_public_path__ + "static/media/feature_7_icon.bafe427e.png";